
import Vue, { PropType } from "vue";

import BaseDialog from "@/components/dialog/BaseDialog.vue";
import { DialogCloseType, DialogI } from "@/types/dialog";
import Btn from "@/components/v2/base/Btn.vue";
import TextareaField from "../form/inputs/TextareaField.vue";
import { TranslateResult } from "vue-i18n";
import { BugReportCategory, BugReportDialogResult } from "@/types/report";
import { whyLineToHtml } from "@/utils/whyLine";

const EXERCISE_CATEGORIES: BugReportCategory[] = ["answer_rejected", "content", "audio", "hint", "other"];
const WORD_CATEGORIES: BugReportCategory[] = ["answer_rejected", "content", "audio", "other"];

export default Vue.extend({
  name: "ReportBugDialog",
  components: {
    BaseDialog,
    Btn,
    TextareaField,
  },

  data() {
    return {
      userComment: "",
      category: undefined as BugReportCategory | undefined,
    };
  },

  computed: {
    isWordType(): boolean {
      return this.dialog?.config?.payload?.type === "word";
    },
    example(): string {
      return this.dialog?.config?.payload?.example;
    },
    correctAnswer(): string {
      return this.dialog?.config?.payload?.correctAnswer;
    },
    userAnswer(): string {
      return this.dialog?.config?.payload?.userAnswer;
    },
    sentenceAnswer(): string {
      return this.dialog?.config?.payload?.sentenceAnswer;
    },
    sentenceExample(): string {
      return this.dialog?.config?.payload?.sentenceExample;
    },
    /** The AI "why" line the report is about; when present the category is fixed to `why_line`. */
    why(): string {
      return this.dialog?.config?.payload?.why || "";
    },
    whyHtml(): string {
      return whyLineToHtml(this.why);
    },
    categories(): BugReportCategory[] {
      if (this.why || this.dialog?.config?.payload?.type === "productionPrompt") {
        return [];
      }
      return this.isWordType ? WORD_CATEGORIES : EXERCISE_CATEGORIES;
    },
    textareaLabel(): TranslateResult {
      if (this.why) {
        return this.$t("dialogs.reportBug.whyPlaceholder");
      }
      if (this.isWordType) {
        return this.$t("dialogs.reportBug.wordPlaceholder");
      }
      if (this.dialog?.config?.payload?.type === "productionPrompt") {
        return this.$t("dialogs.reportBug.productionPromptPlaceholder");
      }
      return this.$t("dialogs.reportBug.placeholder");
    },
  },

  methods: {
    submit() {
      const payload: BugReportDialogResult = {
        comment: this.userComment,
        category: this.why ? "why_line" : this.category,
      };
      this.dialog.close({ type: DialogCloseType.SUBMITTED, payload });
    },
    cancel() {
      this.dialog.close({ type: DialogCloseType.CLOSED });
    },
  },

  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
});
